<template>
  <div class="share-404">
    <div class="img">
      <img src="../assets/imgs/share-404-3x.png" />
    </div>
    <div class="explain">
      请使用手机微信打开小程序
      <span>（需6.5.6及以上版本，暂不支持iPad客户端）</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.share-404 {
  background: #ffffff;
  height: 100%;
  .img {
    padding-top: 0.88rem;
    text-align: center;
    img {
      width: 4rem;
      height: 2.84rem;
    }
  }
  .explain {
    text-align: center;
    font-size: 0.32rem;
    color: #686363;
    display: flex;
    justify-content: center;
    flex-flow: column;
    margin-top: 0.32rem;
    span {
      color: #afaaaa;
      font-size: 0.24rem;
      margin-top: 0.24rem;
    }
  }
}
</style>
